// Generated from grammarLexer.g4 by ANTLR 4.7.2
// jshint ignore: start
var antlr4 = require("antlr4/index");

var serializedATN = [
  "\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964",
  "\u0002\u0012U\b\u0001\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004",
  "\u0004\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t",
  "\u0007\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004",
  "\f\t\f\u0004\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010",
  "\t\u0010\u0004\u0011\t\u0011\u0003\u0002\u0003\u0002\u0003\u0002\u0003",
  "\u0002\u0006\u0002(\n\u0002\r\u0002\u000e\u0002)\u0003\u0003\u0003\u0003",
  "\u0003\u0003\u0006\u0003/\n\u0003\r\u0003\u000e\u00030\u0003\u0004\u0003",
  "\u0004\u0003\u0004\u0003\u0005\u0003\u0005\u0006\u00058\n\u0005\r\u0005",
  "\u000e\u00059\u0003\u0006\u0003\u0006\u0003\u0007\u0003\u0007\u0003",
  "\b\u0003\b\u0003\t\u0003\t\u0003\n\u0003\n\u0003\u000b\u0003\u000b\u0003",
  "\f\u0003\f\u0003\r\u0003\r\u0003\u000e\u0003\u000e\u0003\u000f\u0003",
  "\u000f\u0003\u0010\u0003\u0010\u0003\u0011\u0003\u0011\u0003\u0011\u0003",
  "\u0011\u0002\u0002\u0012\u0003\u0003\u0005\u0004\u0007\u0005\t\u0006",
  "\u000b\u0007\r\b\u000f\t\u0011\n\u0013\u000b\u0015\f\u0017\r\u0019\u000e",
  "\u001b\u000f\u001d\u0010\u001f\u0011!\u0012\u0003\u0002\u0007\u0003",
  "\u0002c|\u0003\u0002C\\\u0003\u00022;\r\u0002##%(*.00<=??AB]]_`}}\u007f",
  '\u0080\u0005\u0002\u000b\u000b\u000e\u000f""\u0002\\\u0002\u0003\u0003',
  "\u0002\u0002\u0002\u0002\u0005\u0003\u0002\u0002\u0002\u0002\u0007\u0003",
  "\u0002\u0002\u0002\u0002\t\u0003\u0002\u0002\u0002\u0002\u000b\u0003",
  "\u0002\u0002\u0002\u0002\r\u0003\u0002\u0002\u0002\u0002\u000f\u0003",
  "\u0002\u0002\u0002\u0002\u0011\u0003\u0002\u0002\u0002\u0002\u0013\u0003",
  "\u0002\u0002\u0002\u0002\u0015\u0003\u0002\u0002\u0002\u0002\u0017\u0003",
  "\u0002\u0002\u0002\u0002\u0019\u0003\u0002\u0002\u0002\u0002\u001b\u0003",
  "\u0002\u0002\u0002\u0002\u001d\u0003\u0002\u0002\u0002\u0002\u001f\u0003",
  "\u0002\u0002\u0002\u0002!\u0003\u0002\u0002\u0002\u0003'\u0003\u0002",
  "\u0002\u0002\u0005.\u0003\u0002\u0002\u0002\u00072\u0003\u0002\u0002",
  "\u0002\t5\u0003\u0002\u0002\u0002\u000b;\u0003\u0002\u0002\u0002\r=",
  "\u0003\u0002\u0002\u0002\u000f?\u0003\u0002\u0002\u0002\u0011A\u0003",
  "\u0002\u0002\u0002\u0013C\u0003\u0002\u0002\u0002\u0015E\u0003\u0002",
  "\u0002\u0002\u0017G\u0003\u0002\u0002\u0002\u0019I\u0003\u0002\u0002",
  "\u0002\u001bK\u0003\u0002\u0002\u0002\u001dM\u0003\u0002\u0002\u0002",
  "\u001fO\u0003\u0002\u0002\u0002!Q\u0003\u0002\u0002\u0002#(\u0005\r",
  "\u0007\u0002$(\u0005\u0005\u0003\u0002%(\u0005\u0007\u0004\u0002&(\u0005",
  "\t\u0005\u0002'#\u0003\u0002\u0002\u0002'$\u0003\u0002\u0002\u0002",
  "'%\u0003\u0002\u0002\u0002'&\u0003\u0002\u0002\u0002()\u0003\u0002",
  "\u0002\u0002)'\u0003\u0002\u0002\u0002)*\u0003\u0002\u0002\u0002*\u0004",
  "\u0003\u0002\u0002\u0002+/\u0005\u000b\u0006\u0002,/\u0005\u000f\b\u0002",
  "-/\u0005\u001b\u000e\u0002.+\u0003\u0002\u0002\u0002.,\u0003\u0002\u0002",
  "\u0002.-\u0003\u0002\u0002\u0002/0\u0003\u0002\u0002\u00020.\u0003\u0002",
  "\u0002\u000201\u0003\u0002\u0002\u00021\u0006\u0003\u0002\u0002\u0002",
  "23\u0005\r\u0007\u000234\u0005\u0011\t\u00024\b\u0003\u0002\u0002\u0002",
  "57\u0005\r\u0007\u000268\u0005\u001d\u000f\u000276\u0003\u0002\u0002",
  "\u000289\u0003\u0002\u0002\u000297\u0003\u0002\u0002\u00029:\u0003\u0002",
  "\u0002\u0002:\n\u0003\u0002\u0002\u0002;<\t\u0002\u0002\u0002<\f\u0003",
  "\u0002\u0002\u0002=>\t\u0003\u0002\u0002>\u000e\u0003\u0002\u0002\u0002",
  "?@\t\u0004\u0002\u0002@\u0010\u0003\u0002\u0002\u0002AB\u0007)\u0002",
  "\u0002B\u0012\u0003\u0002\u0002\u0002CD\u0007a\u0002\u0002D\u0014\u0003",
  "\u0002\u0002\u0002EF\u0007\u2194\u0002\u0002F\u0016\u0003\u0002\u0002",
  "\u0002GH\u0007\u03bd\u0002\u0002H\u0018\u0003\u0002\u0002\u0002IJ\u0007",
  "~\u0002\u0002J\u001a\u0003\u0002\u0002\u0002KL\t\u0005\u0002\u0002L",
  "\u001c\u0003\u0002\u0002\u0002MN\u0004\u2082\u208b\u0002N\u001e\u0003",
  "\u0002\u0002\u0002OP\u0007\f\u0002\u0002P \u0003\u0002\u0002\u0002Q",
  "R\t\u0006\u0002\u0002RS\u0003\u0002\u0002\u0002ST\b\u0011\u0002\u0002",
  "T\"\u0003\u0002\u0002\u0002\b\u0002').09\u0003\b\u0002\u0002",
].join("");

var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map(function (ds, index) {
  return new antlr4.dfa.DFA(ds, index);
});

function grammarLexer(input) {
  antlr4.Lexer.call(this, input);
  this._interp = new antlr4.atn.LexerATNSimulator(
    this,
    atn,
    decisionsToDFA,
    new antlr4.PredictionContextCache()
  );
  return this;
}

grammarLexer.prototype = Object.create(antlr4.Lexer.prototype);
grammarLexer.prototype.constructor = grammarLexer;

Object.defineProperty(grammarLexer.prototype, "atn", {
  get: function () {
    return atn;
  },
});

grammarLexer.EOF = antlr4.Token.EOF;
grammarLexer.WDCOMPLEX = 1;
grammarLexer.WDSYMDIG = 2;
grammarLexer.APOSUPPW = 3;
grammarLexer.UNIUPPW = 4;
grammarLexer.LOWW = 5;
grammarLexer.UPPW = 6;
grammarLexer.DIGITS = 7;
grammarLexer.APOSTROPHE = 8;
grammarLexer.UNDERSCORE = 9;
grammarLexer.ARROW = 10;
grammarLexer.LAMBDA = 11;
grammarLexer.PIPE = 12;
grammarLexer.SYMBOLS = 13;
grammarLexer.NUMUNI = 14;
grammarLexer.NEWLINE = 15;
grammarLexer.WS = 16;

grammarLexer.prototype.channelNames = ["DEFAULT_TOKEN_CHANNEL", "HIDDEN"];

grammarLexer.prototype.modeNames = ["DEFAULT_MODE"];

grammarLexer.prototype.literalNames = [
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  "'''",
  "'_'",
  "'\u2192'",
  "'\u03BB'",
  "'|'",
  null,
  null,
  "'\n'",
];

grammarLexer.prototype.symbolicNames = [
  null,
  "WDCOMPLEX",
  "WDSYMDIG",
  "APOSUPPW",
  "UNIUPPW",
  "LOWW",
  "UPPW",
  "DIGITS",
  "APOSTROPHE",
  "UNDERSCORE",
  "ARROW",
  "LAMBDA",
  "PIPE",
  "SYMBOLS",
  "NUMUNI",
  "NEWLINE",
  "WS",
];

grammarLexer.prototype.ruleNames = [
  "WDCOMPLEX",
  "WDSYMDIG",
  "APOSUPPW",
  "UNIUPPW",
  "LOWW",
  "UPPW",
  "DIGITS",
  "APOSTROPHE",
  "UNDERSCORE",
  "ARROW",
  "LAMBDA",
  "PIPE",
  "SYMBOLS",
  "NUMUNI",
  "NEWLINE",
  "WS",
];

grammarLexer.prototype.grammarFileName = "grammarLexer.g4";

exports.grammarLexer = grammarLexer;
